<!-- eslint-disable vue/valid-v-bind -->
<template>
  <b-modal
    id="temporary-contract-modal"
    centered
    title="Sijaisuus"
    ok-title="Luo"
    cancel-title="Peruuta"
    modal-class="modal-primary"
    no-close-on-backdrop
    :ok-disabled="
      !accountSelected ||
        !contractSelected ||
        (typeContract === 'exist_contract' && !documentUuid) ||
        (typeContract === 'new_contract' && locationText.length < 2) ||
        (typeContract === 'new_contract' && salaryText.length < 2) ||
        startTempContractStr === '' ||
        endTempContractStr === '' ||
        !hours ||
        hours === ''
    "
    @ok="createTemporaryContract(isBoosted)"
    @hide="resetTemporaryContractForm"
  >
    <b-form-group label="Valitse asiakas" label-for="select-account">
      <v-select
        v-model="accountSelected"
        :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
        :options="accountOptions"
        class="capitalized"
        :clearable="false"
      />
      <small v-if="!accountSelected" class="text-danger">
        {{ $t('personel.temp_contract.modal.warnings.required_account') }}
      </small>
    </b-form-group>
    <template v-if="accountSelected">
      <b-form-group label="Valitse sopimus" label-for="select-contract">
        <v-select
          v-model="contractSelected"
          :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
          :options="contractOptions"
          class="capitalized"
          :clearable="false"
        />
        <small v-if="!contractSelected" class="text-danger">
          {{ $t('personel.temp_contract.modal.warnings.required_contract') }}
        </small>
      </b-form-group>
      <b-form-group label="Valitse kohde" label-for="select-area">
        <v-select
          v-model="areaTempContractSelected"
          :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
          :options="areaTempContractOptions"
          class="capitalized"
          :clearable="false"
        />
        <small v-if="!areaTempContractSelected" class="text-danger">
          {{ $t('personel.temp_contract.modal.warnings.required_area') }}
        </small>
      </b-form-group>
      <b-row>
        <b-col md="6">
          <b-form-group label="Sijaisuus alkaa" label-for="start">
            <flat-pickr
              v-model="startTempContractStr"
              class="form-control"
              :config="{ time_24hr: true }"
              @on-change="
                date => {
                  setDate(date, 'startTempContract')
                  updateMaxDate(date)
                }
              "
            />
            <small v-if="startTempContractStr === ''" class="text-danger">
              {{ $t('personel.temp_contract.modal.warnings.required_start_date') }}
            </small>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Loppuu" label-for="end">
            <flat-pickr
              v-model="endTempContractStr"
              class="form-control"
              :config="{ minDate: startTempContract, time_24hr: true, maxDate }"
              @on-change="
                date => {
                  setDate(date, 'endTempContract')
                }
              "
            />
            <small v-if="endTempContractStr === ''" class="text-danger">
              {{ $t('personel.temp_contract.modal.warnings.required_end_date') }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            label="Työtunnit (vko)"
          >
            <b-form-input
              v-model="hours"
            />
            <small v-if="!hours || hours === ''" class="text-danger">
              Työtunnit vaaditaan
            </small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" style="margin-bottom: 15px;">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <b-form-checkbox v-model="isBoosted">
              Bonus
            </b-form-checkbox>
            <b-form-checkbox v-if="isBoosted" v-model="bonus.recurring" style="margin-inline: 10px">
              {{ $t('recurring') }}
            </b-form-checkbox>
            <b-form-checkbox v-if="bonus.recurring" v-model="bonus.paidEndOfMonth" style="margin-left: 10px">
              {{ $t('paid_end_of_month') }}
            </b-form-checkbox>
          </div>
          <div v-if="isBoosted" style="display: flex; flex-direction: row; align-items: center; margin-top: 10px;">
            <b-form-input
              v-model="bonus.amount"
              :placeholder="$t('bonus_amount')"
            />
            <v-select
              v-model="bonus.condition"
              :options="conditions"
              style="min-width: 60%; margin-left: 10px;"
              :placeholder="$t('payment_condition')"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="5">
          <b-form-group
            :label="$t('personel.temp_contract.modal.radiobox.title')"
            label-for="typeContract"
          >
            <b-form-radio-group v-model="typeContract" button-variant="outline-primary">
              <b-form-radio value="exist_contract">
                {{ $t('personel.temp_contract.modal.radiobox.exist_contract') }}
              </b-form-radio>
              <b-form-radio value="new_contract" class="mt-1">
                {{ $t('personel.temp_contract.modal.radiobox.new_contract') }}
              </b-form-radio>
              <b-form-radio value="no_contract" class="mt-1">
                {{ $t('personel.temp_contract.modal.radiobox.no_contract') }}
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col md="7">
          <b-form-group label="Sopimuksen UID (jos on olemassa)" label-for="document-uuid">
            <b-form-input
              id="document-uuid"
              v-model="documentUuid"
              :disabled="typeContract !== 'exist_contract'"
            />
            <small v-if="typeContract === 'exist_contract' && !documentUuid" class="text-danger">
              {{ $t('personel.temp_contract.modal.warnings.required_document_id') }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="typeContract === 'new_contract'">
        <!-- Location of the contract text -->
        <b-col md="12">
          <b-form-group label="Sopimuksessa näkyvä sijainti teksti" label-for="contract-location">
            <b-form-textarea
              id="contract-location"
              v-model="locationText"
              :disabled="typeContract !== 'new_contract'"
            />
            <small v-if="typeContract === 'new_contract' && !locationText" class="text-danger">
              {{ $t('personel.temp_contract.modal.warnings.required_contract_location') }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="typeContract === 'new_contract'">
        <!-- Salary of the contract text -->
        <b-col md="12">
          <b-form-group label="Sopimuksessa näkyvä palkka teksti" label-for="contract-salary">
            <b-form-textarea
              id="contract-salary"
              v-model="salaryText"
              :disabled="typeContract !== 'new_contract'"
            />
            <small v-if="typeContract === 'new_contract' && !salaryText" class="text-danger">
              {{ $t('personel.temp_contract.modal.warnings.required_contract_location') }}
            </small>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup,
  BFormRadio,
  BModal,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ref, computed, watch } from '@vue/composition-api'
import { getSalary } from '@/shared/services/payrollService'
import store from '@/shared/store'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { db } from '@/shared/services/firebase'

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormRadio,
    BModal,
    BFormTextarea,
    BFormCheckbox,

    vSelect,
    flatPickr,
  },
  props: {
    userData: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      isBoosted: false,
      bonus: {
        amount: null,
        condition: null,
        recurring: false,
        paidEndOfMonth: false,
      },
      conditions: [
        {label: 'Enintään 3 sairaspäivää', value: 'max_three_sick_days'},
        {label: 'Vähintään 150 tuntia suoritettu', value: 'min_150_hours_completed'},
        {label: 'Tehtyjen vuorojen prosenttiosuus', value: 'completed_shifts_percentage'}
      ],
      maxDate: null,
    }
  },
  methods: {
    updateMaxDate(date) {
      const maxDate = new Date()
      maxDate.setMonth(date[0].getMonth() + 3)
      this.maxDate = maxDate
    },
  },
  setup(props, { emit }) {
    const { userData } = props
    const accountSelected = ref(null)
    const accountOptions = computed(() => store.state.appAccount.accounts)
    const contractSelected = ref(null)
    const contractOptions = ref([])
    const documentUuid = ref('')
    const typeContract = ref('no_contract')
    const areaTempContractSelected = ref(null)
    const areaTempContractOptions = ref([])
    const startTempContractStr = ref('')
    const endTempContractStr = ref('')
    const startTempContract = ref('')
    const endTempContract = ref('')
    const locationText = ref('')
    const salaryText = ref('')
    const hours = ref(null)
    const isBoosted = ref(false)
    const bonus = ref({
      amount: null,
      condition: null,
      recurring: false,
      paidEndOfMonth: false,
    })

    const role = store.getters.userRole(userData.role)

    let processer = {}

    store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      processer = {
        firstName: user.firstName,
        lastName: user.lastName,
      }
    })

    const fetchAreaListTempContract = ({ accountId }) => {
      db.collection('areas')
        .where('accountId', '==', accountId)
        .get()
        .then(snapshot => {
          areaTempContractOptions.value = snapshot.docs.map(doc => {
            const item = doc.data()
            item.id = doc.id
            return {
              label: item.name,
              value: item,
            }
          })
        })
    }

    const setDate = (date, slot) => {
      if (slot === 'startTempContract') {
        ;[startTempContract.value] = date
      }
      if (slot === 'endTempContract') {
        ;[endTempContract.value] = date
        endTempContract.value.setHours(23, 59, 59, 0)
      }

      if (endTempContract.value < startTempContract.value) {
        endTempContract.value = null
        endTempContractStr.value = ''
      }
    }

    const createTemporaryContract = () => {
      const newTempContract = {
        typeContract: typeContract.value,
        startDate: startTempContract.value,
        endDate: endTempContract.value,
        accountId: accountSelected.value.value.id,
        contractId: contractSelected.value.value.id,
        areaId: areaTempContractSelected.value.value.id,
        hours: Number(hours.value),
        workContract: {
          documentUuid: documentUuid.value,
          sent: true,
          signed: typeContract.value !== 'new_contract',
        },
        processer: `${processer.firstName} ${processer.lastName}`,
      }
      if (isBoosted.value) {
        newTempContract.bonus = {
          ...bonus.value,
          condition: bonus.value.condition === null ? bonus.value.condition : bonus.value.condition.value
        }
      }

      emit('create-temp-contract', newTempContract, locationText.value, salaryText.value)
    }

    const resetTemporaryContractForm = () => {
      accountSelected.value = null
      contractSelected.value = null
      contractOptions.value = []
      documentUuid.value = ''
      typeContract.value = 'exist_contract'
      areaTempContractSelected.value = null
      areaTempContractOptions.value = []
      startTempContractStr.value = ''
      endTempContractStr.value = ''
      startTempContract.value = ''
      endTempContract.value = ''
      hours.value = null
      bonus.value = {
        amount: null,
        condition: null,
        recurring: false,
        paidEndOfMonth: false,
      }
    }

    const fetchContractsByAccount = ({ accountId }) => {
      db.collection('contracts')
        .where('accountId', '==', accountId)
        .get()
        .then(async snapshot => {
          const data = snapshot.docs.map(doc => {
            const item = doc.data()
            item.id = doc.id
            return { label: item.name, value: item }
          })
          contractOptions.value = data
        })
        .catch(() => {})
    }

    watch(accountSelected, newVal => {
      if (newVal) {
        contractSelected.value = null
        fetchContractsByAccount({ accountId: newVal.value.id })
        fetchAreaListTempContract({ accountId: newVal.value.id })
      }
    })

    watch(contractSelected, newVal => {
      if (newVal) {
        const { salary } = newVal.value
        const salaryValue = getSalary({ role }, salary) * 1.09
        salaryText.value = `${capitalize(role.label)} palkka ${salaryValue.toFixed(
          2
        )} Eur/t (sis.lomakorvaus.) + vuorolisät`
      }
    })

    watch(areaTempContractSelected, newVal => {
      if (newVal) {
        const { location } = newVal.value
        const {
          address: { streetAddress, city },
          sectionInfo,
        } = location
        locationText.value = `${sectionInfo}: ${streetAddress} ${city}`
      }
    })

    watch(typeContract, newVal => {
      if (newVal !== 'exist_contract') {
        documentUuid.value = ''
      }
    })

    return {
      accountSelected,
      accountOptions,
      contractSelected,
      contractOptions,
      documentUuid,
      typeContract,
      areaTempContractSelected,
      areaTempContractOptions,
      startTempContract,
      endTempContract,
      startTempContractStr,
      endTempContractStr,
      locationText,
      salaryText,
      setDate,
      isBoosted,
      bonus,
      hours,

      createTemporaryContract,
      resetTemporaryContractForm,
    }
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
.capitalized {
  text-transform: capitalize;
}
</style>
